// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3v16S","vLegacy":"SelectSecondary_vLegacy__VS7iO","error":"SelectSecondary_error__MknXn","disabled":"SelectSecondary_disabled__2-juO"};